// ==================== NewsSection.jsx ====================
import React, { useEffect, useState } from "react";
import {
  Gift,
  PartyPopper,
  Users,
  CalendarDays,
  UserPlus,
  LogOut,
  LogInIcon
} from "lucide-react";
import "../Styling/NewsSection.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";

const NewsSection = () => {
  const { user } = useAuth();

  const [openSection, setOpenSection] = useState("today");

  const [todayEvents, setTodayEvents] = useState({
    Birthday: [],
    "Work Anniversary": [],
    "New Joinee": [],
    Exit: [],
    Confirmation: [],
  });

  const [upcomingEvents, setUpcomingEvents] = useState({
    Birthday: [],
    "Work Anniversary": [],
    "New Joinee": [],
    Exit: [],
    Confirmation: [],
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const next30 = new Date(today);
  next30.setDate(today.getDate() + 30);

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const getIcon = (type) => {
    switch (type) {
      case "Birthday":
        return <Gift size={14} />;
      case "Work Anniversary":
        return <PartyPopper size={14} />;
      case "New Joinee":
        return <UserPlus size={14} />;
        case "Exit":
  return <LogOut size={14} />;
  case "Confirmation":
  return <LogInIcon size={14} />;

      default:
        return <Users size={14} />;
    }
  };

  useEffect(() => {
    if (!user?.organisationId) return;

    const fetchEmployees = async () => {
      try {
        const response = await fetch(
          `${Base_URL}/SalaryProcess/ResourceMasters/${user.organisationId}`
        );

        const text = await response.text();
        const data = text ? JSON.parse(text) : [];
        const exitRes = await fetch(
  `${Base_URL}/Resource/upcoming-exits/${user.organisationId}`
);

const exitJson = await exitRes.json();
const exits = exitJson?.data || [];

//confirmation 
const confRes = await fetch(
  `${Base_URL}/Resource/upcoming-confirmations/${user.organisationId}`
);
const confJson = await confRes.json();
const confirmations = confJson?.data || [];

        const activeEmployees = data.filter(
          (emp) =>
            String(emp.active) === "1" ||
            String(emp.active).toLowerCase() === "true"
        );

        const todayGrouped = {
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
           Exit: [],
            Confirmation: [],
        };

        const upcomingGrouped = {
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
           Exit: [],
            Confirmation: [],
        };

        const sortByDate = (grouped) => {
          Object.keys(grouped).forEach((key) => {
            grouped[key].sort(
              (a, b) => new Date(a.sortDate) - new Date(b.sortDate)
            );
          });
        };

        activeEmployees.forEach((emp) => {
          const dob = emp.dob ? new Date(emp.dob) : null;
          const doj = emp.doj ? new Date(emp.doj) : null;

          if (doj) doj.setHours(0, 0, 0, 0);

          const base = {
            name: emp.name,
            role: emp.role,
            department: emp.department,
          };

          /* ------------ Birthdays ------------ */

          if (dob) {
            const birthdayThisYear = new Date(dob);
            birthdayThisYear.setFullYear(today.getFullYear());

            if (birthdayThisYear.toDateString() === today.toDateString()) {
              todayGrouped.Birthday.push({
                ...base,
                date: "Today",
                sortDate: today,
              });
            } else if (birthdayThisYear > today && birthdayThisYear <= next30) {
              upcomingGrouped.Birthday.push({
                ...base,
                date: birthdayThisYear.toDateString(),
                sortDate: birthdayThisYear,
              });
            }
          }

          /* ------------ Work Anniversary ------------ */

          if (doj) {
            const anniversaryThisYear = new Date(doj);
            anniversaryThisYear.setFullYear(today.getFullYear());

            if (anniversaryThisYear.toDateString() === today.toDateString()) {
              todayGrouped["Work Anniversary"].push({
                ...base,
                date: "Today",
                sortDate: today,
              });
            } else if (anniversaryThisYear > today && anniversaryThisYear <= next30) {
              upcomingGrouped["Work Anniversary"].push({
                ...base,
                date: anniversaryThisYear.toDateString(),
                sortDate: anniversaryThisYear,
              });
            }

            /* ------------ ✅ New Joinee Logic ------------ */

            // Today joiner (full DOJ match)
            if (doj.getTime() === today.getTime()) {
              todayGrouped["New Joinee"].push({
                ...base,
                date: "Today",
                sortDate: doj,
              });
            }

            // Upcoming joiners (next 30 days)
            if (doj > today && doj <= next30) {
              upcomingGrouped["New Joinee"].push({
                ...base,
                date: doj.toDateString(),
                sortDate: doj,
              });
            }
          }
        });

        // exit loop
        exits.forEach((e) => {
  if (!e.leftDate) return;

  const left = new Date(e.leftDate);
  left.setHours(0, 0, 0, 0);

  const exitBase = {
    name: e.name,
    role: e.role,
    department: e.department,
    date: left.toDateString(),
    sortDate: left,
  };

  // Today Exit
  if (left.getTime() === today.getTime()) {
    todayGrouped.Exit.push({
      ...exitBase,
      date: "Today",
    });
  }

  // Upcoming Exit (already filtered by API)
  else {
    upcomingGrouped.Exit.push(exitBase);
  }
});

//confirmation loop
confirmations.forEach((e) => {
  if (!e.confirmationDate) return;

  const confirm = new Date(e.confirmationDate);
  confirm.setHours(0, 0, 0, 0);

  const confirmBase = {
    name: e.name,
    role: e.role,
    department: e.department,
    date: confirm.toDateString(),
    sortDate: confirm,
  };

  // Today confirmation
  if (confirm.getTime() === today.getTime()) {
    todayGrouped["Confirmation"].push({
      ...confirmBase,
      date: "Today",
    });
  }

  // Upcoming cocnfirmation (already filtered by API)
  else {
    upcomingGrouped["Confirmation"].push(confirmBase);
  }
});


        sortByDate(todayGrouped);
        sortByDate(upcomingGrouped);

        setTodayEvents(todayGrouped);
        setUpcomingEvents(upcomingGrouped);
      } catch (error) {
        console.error("Error fetching employee events:", error);
      }
    };

    fetchEmployees();
  }, [user?.organisationId]);

  const renderSection = (title, icon, data, type, key) => {
    const isOpen = openSection === key;

    return (
      <div className="news-section">
        <div
          className={`news-section-title ${type} dropdown-header`}
          onClick={() => toggleSection(key)}
        >
          <div className="dropdown-left">
            {icon} {title}
          </div>
          <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>▾</span>
        </div>

        <div className={`news-dropdown ${isOpen ? "open" : ""}`}>
          <div className="news-horizontal-row">
            {Object.entries(data).map(([k, items]) => (
              <div key={k} className="news-box">
                <div className="news-box-title">
                  {getIcon(k)} {k}
                </div>

                {items.length === 0 ? (
                  <p className="news-empty">No events</p>
                ) : (
                  items.map((item, idx) => (
                    <div key={idx} className="news-item">
                      <p className="news-name">{item.name}</p>
                      <p className="news-sub">
                        {item.role} • {item.department}
                      </p>
                      <span className="news-date">{item.date}</span>
                    </div>
                  ))
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="news-card compact">
      <div className="news-header">
        <Users size={18} />
        <div>
          <h4>News & Events</h4>
          <p>Birthdays, anniversaries joinees, exits & confirmations</p>
        </div>
      </div>

      {renderSection("Today", <Users size={14} />, todayEvents, "today", "today")}
      {renderSection(
        "Upcoming (30 Days)",
        <CalendarDays size={14} />,
        upcomingEvents,
        "upcoming",
        "upcoming"
      )}
    </div>
  );
};

export default NewsSection;
